import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import { useAnalytics } from "@/lib/useAnalytics";
import { CartProvider } from "@/context/CartContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import News from "@/pages/News";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Site = () => {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const { settings } = useSettings();
  // Not on the admin pages: measuring your own visits skews the numbers you
  // are measuring, and there is nothing to learn from them anyway.
  useAnalytics(isAdmin ? null : settings?.analytics);
  return (
    <>
      {!isAdmin && <Navbar />}
      <AnimatePresence>
        <Routes location={loc} key={loc.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/produtos" element={<Products />} />
          <Route path="/produto/:id" element={<ProductDetail />} />
          <Route path="/novidades" element={<News />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/contactos" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </AnimatePresence>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <CartDrawer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <ReactLenis root>
              <BrowserRouter>
                <Site />
                <Toaster position="top-center" richColors />
              </BrowserRouter>
            </ReactLenis>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
